import React, { useContext, useEffect, useState } from "react";

import estilo from "./styles/ListaContactos.module.css";
import Contactos from "../components/Contactos";
import { usePageVisibility } from "react-page-visibility";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";

function ListaContactos() {
  const { usuario, url, click } = useContext(DataContext);

  //controlador
  const isVisible = usePageVisibility();

  React.useEffect(() => {
    if (isVisible) {
      actualizarEstado(true);
    } else {
      actualizarEstado(false);
    }
  }, [isVisible]);

  async function actualizarEstado(conectado) {
    await supabase
      .from("usuarios_chat")
      .update({ estado: conectado })
      .eq("user_id", usuario.id);
  }

  return (
    <div className={estilo.lista_contactos}>
      <Contactos></Contactos>
    </div>
  );
}

export default ListaContactos;
